import {
  FAVORITE_STORES_VIEW,
  FAVORITE_STORES_MANAGE_FAVORITES_TILE_VIEW,
  CLEAR_FAVORITE_STORES_LIST,
} from './types';

export const triggerFavoriteStoresIsViewed = (merchants) => ({
  type: FAVORITE_STORES_VIEW,
  merchants,
});

export const triggerFavoriteStoresManageFavoritesTileIsViewed = () => ({
  type: FAVORITE_STORES_MANAGE_FAVORITES_TILE_VIEW,
});

export const clearFavoriteStoresList = () => ({
  type: CLEAR_FAVORITE_STORES_LIST,
});
